<template>
<div>
    <Breadcrumbs main="Procuremnet" submain="Create" title="GRN" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <px-card>
                    <div slot="with-padding">
                        <div class="form theme-form">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Purchase Order</label>
                                        <v-select class="custom-vue-select" :options="po" label="purchase_order_id" :reduce="po => po.id" v-model="grn.purchase_order" placeholder="Select a Purchase Order"></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group" >
                                        <label>Received Date</label>
                                        <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" v-model="grn.received_date"></datepicker>
                                    </div>
                                </div>
                            </div>

                            <div class="table-responsive datatable-vue mt-4" v-if="grn.purchase_order">
                                <b-table show-empty stacked="md" :items="grn.items" :fields="tablefields" small>
                                    <!-- Index -->
                                    <template #cell(index)="data">
                                        {{ data.index + 1 }}
                                    </template>

                                    <!-- Item Name -->
                                    <template #cell(name)="data">
                                        {{ data.item.po_item_name }}
                                    </template>

                                    <!-- Editable Quantity -->
                                    <template #cell(quantity_received)="data">
                                        <input type="number" class="form-control" v-model.number="data.item.quantity_received" min="0" />
                                    </template>
                                </b-table>
                            </div>

                            <div class="row mt-3">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Notes</label>
                                        <textarea class="form-control" id="exampleFormControlTextarea4" placeholder="Enter note..." rows="2" v-model="grn.notes"></textarea>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group mb-0">
                                        <button @click="onSubmit" class="btn btn-success mr-3" :disabled="isDisabled">Create</button>
                                        <router-link to="/procurement/grn">
                                            <button class="btn btn-danger" href="#">Go Back</button>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </px-card>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import {
    computed
} from "vue";
import Datepicker from 'vuejs-datepicker';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import ItemTable from "./item-table.vue";
import Multiselect from 'vue-multiselect';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import moment from "moment";

export default {
    components: {
        vueDropzone: vue2Dropzone,
        Datepicker,
        ItemTable,
        Multiselect,
        'v-select': vSelect
    },

    data() {
        return {
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'name',
                    label: 'Item Name'
                },
                {
                    key: 'quantity_received',
                    label: 'Quantity Received'
                }
            ],
            editor: ClassicEditor,
            isDisabled: false,
            grn: {
                purchase_order: null,
                received_date: null,
                notes: '',
                items: []
            }
        }
    },

    computed: {
        ...mapState({
            po: state => state.purchase_order.purchase_order_withoutpg
        })
    },

    watch: {
        'grn.purchase_order'(newVal) {
            this.$store.dispatch('purchase_order/fetchPODetail', newVal).then((response) => {
                const orderItems = response.order_items || []
                this.grn.items = orderItems.map(item => ({
                    po_item_name: item.name,
                    po_item: item.id,
                    quantity_received: Number(item.quantity)
                }))
            })
        }
    },

    mounted() {
        this.grn.received_date = moment().format("YYYY-MM-DD");
        this.$store.dispatch("purchase_order/fetchPOWithoutPG")
    },

    methods: {
        updateItems(data) {
            if (data) {
                this.requisition.items = data;
            }
        },

        onSubmit() {
            this.isDisabled = true;

            const payload = {
                ...this.grn,
                received_date: this.grn.received_date 
                    ? moment(this.grn.received_date).format("YYYY-MM-DD") 
                    : null
            };

            this.$store.dispatch("grn/addGRN", payload).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.grn.purchase_order = null
                    this.grn.notes = []
                    this.grn.items = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
                setTimeout(() => this.$router.push('/procurement/grn'), 2000)
            })
            this.isDisabled = false
        }
    }
};
</script>
